import { Container, Stack, Text, Title } from '@mantine/core';
import React from 'react';
import { Breadcrumb } from '../../components/common/Breadcrumb';
import { EmployeeDictionaryManagement } from '../../features/employee-hub';
import { EmployeeDictionaryType } from '../../models/employeeHub';

export const OperationsWorkSchedulesManagement: React.FC = () => {
    return (
        <Container size="xl" py="xl">
            <Stack gap="xl">
                <div>
                    <Breadcrumb
                        items={[
                            { label: 'Operations Panel', href: '/operations' },
                            { label: 'Employee', href: '/operations/employee-hub' },
                            { label: 'Work Schedules', isActive: true },
                        ]}
                    />
                    <Title order={1} size="h2" fw={700}>
                        Work Schedules
                    </Title>
                    <Text c="dimmed" size="lg">
                        Manage work schedule codes and display names
                    </Text>
                </div>

                <EmployeeDictionaryManagement
                    type={EmployeeDictionaryType.WorkSchedule}
                    title="Work Schedules"
                    searchPlaceholder="Search work schedules..."
                />
            </Stack>
        </Container>
    );
};
